import { render } from "./ModalItem.vue?vue&type=template&id=149b24d0&scoped=true"
import script from "./ModalItem.vue?vue&type=script&lang=js"
export * from "./ModalItem.vue?vue&type=script&lang=js"

import "./ModalItem.vue?vue&type=style&index=0&id=149b24d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-149b24d0"]])

export default __exports__